export default "/images/98fbee964bd3c4da16c93d0b13991ecb.avif";